import { render, staticRenderFns } from "./FiledataEditDialog.vue?vue&type=template&id=fa56d9a8&scoped=true&"
import script from "./FiledataEditDialog.vue?vue&type=script&lang=js&"
export * from "./FiledataEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa56d9a8",
  null
  
)

export default component.exports